import React, { useState, useRef } from "react";
import { useEffect } from "react";
import axiosInstance from "../../helpers/axios";
import axiosComponentsAPIInstance from "../../helpers/componentsApi";
import HomeBanner from "../HomeBanner";
import ImageBanner from "../ImageBanner";
import VideoBanner from "../VideoBanner";
import { ProductListContext } from "../../context/ProductListContext";
import { LeftMenuContext } from "../../context/LeftMenuContext";
import "./home.css";
import { getPromoBanners } from "./home.utils";
import { Modal} from "@kui-react/modal";
import ItemGridView from "../ProductsList/ItemGridView";
import localeConstants from "../../i18n/localization";
import { Button } from "@kui-react/button";
import { Select, SelectItem } from "@kui-react/select";
import SideBar from "../Sidebar/sidebar";
import SideMenu from "../SidePanel/sidePanel";
import { useSearchParams, useLocation } from "react-router-dom";
import "../ProductsList/products.css";
import ItemProductPanel from "../ProductsList/ItemProductPanel";
import Tag from "../filterBubble"
import {GlobalHeader,Footer} from "@ecl/react";
// import logo from "../../assets/images/nv-logo.png";
// import { Container, Grid } from '@kui-react/grid'
import { Flex } from '@kui-react/flex'
const Index = () => {
  const loaderIcon = "https://store.nvidia.com/etail/loading.gif";
  let productState = React.useContext(ProductListContext);
  const sideBarState = React.useContext(LeftMenuContext);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const theme_clr = "dark";
  const {
    heroBanner,
    setHeroBanner,
    activeTab,
    setActiveTab,
    setTabList,
    tabList,
    promoBanners,
    setPromoBanners,
    homeBanner,
    setHomeBanners,
    productsList,
    setProductsList,
    pagination,
    setPagination,
    setIsOpen,
    redirectURL,
    setRedirectUrl
  } = productState;
  const {
    priceSort,
    setPriceSort,
    catWithSubCat,
    setCatWithSubCat,
    setPriceFilter,
    setSliderMinMax,
    applyPriceFilter,
    setApplyPriceFilter
  } = sideBarState;
  const brandstore = document.getElementById("nvidia_brandstore_widget");
  const themename = brandstore.getAttribute("data-brandstore-theme");
  const [locale, setLocale] = useState("US");
  const localeStrings = localeConstants[locale?.toUpperCase()];
  const brandstoreName = brandstore.getAttribute("data-brandstore");
   let brandstoreId;
  // eslint-disable-next-line no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [ setOpenRetailDetail] = useState(false);
  const [ setRetailProductObject] = useState("");
  const [ setRetailProductTitle] = useState("");
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [view, setView] = useState("GridView");
  const [page, setPage] = useState(1);
  const [loadMoreProducts, setLoadMoreProducts] = useState(false);
  const [width, setWidth] = useState(window.screen.width);
  const [isFiltersideOpen, setFiltersideOpen] = useState(true);
  const [new_arr1, setnew_arr1] = useState([]);
  const [FilterFlag, setFilterFlag] = useState(false);
  const [NoProductFlag, setNoProductFlag] = useState(false);
  const [NameBrandstore, setNameBrandstore] = useState("");
  const [ResetFilterState, setResetFilterState] = useState(false);
  const [defaultSortValue, setdefaultSortValue] = useState("")
   const [headerData, setHeaderData] = useState(null)
  // const [filterDisplayFlag, setfilterDisplayFlag] = useState(false);
  const sortingValue = [{
    "lp": "LowestPrice",
    "hp": "HighestPrice",
    "fp": "FeaturedProducts",
    "rt": "Rating",
    "dp": "DiscountedPrice",
  }]
  var list = [...sideBarState.catWithSubCat];
  const spec = [{

    'GPU': [{
      'gpu': 'GPU',
      'gpu_clock_speed': 'Boost Clock Speed',
      'memory_type': 'Memory',
      'gpu_memory_size':"GPU Memory Size"
    }],
    'Laptop': [{
      'gpu': 'GPU',
      'screen_size': 'Display',
      'memory_type': 'Memory',
      'processor': 'Processor',
      'hdd_size': 'Storage'
    }],
    'DESKTOP': [{
      'gpu': 'GPU',
      'screen_size': 'Display',
      'memory_type': 'Memory',
      'processor': 'Processor',
      'hdd_size': 'Storage'
    }]
  }];

  const getHeader = async () => {
    const currentLocale = "en-us"
    try {
      const response = await fetch(
        `https://marketplace.nvidia.com/menus/consumer-navigation-${currentLocale}.json?brand=geforce&mountId=main-header&is_cart=false`
      );
   
      if (!response.ok) {
        throw new Error(`Failed to fetch data for locale: ${currentLocale}`);
      }
   
      const apiData = await response.json();
   
      console.log("API Data fetched successfully:", apiData);
      setHeaderData(apiData)
    } catch (error) {
      console.error("Error in getStaticProps:", error);
      return { notFound: true };
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const Filterselect =
      new_arr1?.map((k) => k.filter((v) =>
        (v && v.name === "fitler_sub_category" && v.value === urlParams.get("category")) ||
        (v && v.name === "existing_component_id")
      ));
    // new_arr1?.map((k) => k.filter((v) => v && v.name === "fitler_sub_category" && v.value === urlParams.get("category") || v && v.name === "existing_component_id"));
    const filterId = Filterselect.filter((k) => k && k.length === 2)
    const bannerAr = [];
    filterId.forEach((cat) => {
      const id = cat.filter(
        (item) => item.name === "existing_component_id"
      );
      bannerAr.push(id[0]?.value);
    });
    if (bannerAr.length > 0) {
      let componentsUrl = "/store/v1/components?ids=[" + bannerAr + "]";
      axiosComponentsAPIInstance.get(componentsUrl).then((res) => {
        let Filterdata = getPromoBanners(res?.data?.response);
        Filterdata = Filterdata.filter((banner) => banner.bannerType === 'heroBanner');
        setHeroBanner(Filterdata[0]);
        let promoData = getPromoBanners(res?.data?.response);
        promoData = promoData.filter((banner) => banner.bannerType === 'largePromoBanner');
        setPromoBanners(promoData);
      });
    }
    // eslint-disable-next-line
  }, [new_arr1]);

  useEffect(() => {
    getHeader();
    if (urlParams.get("tab_id")) {

    }
    else {
      // getData(null);
    }
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };   
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (NameBrandstore) {
      callEtail("PAGE_VIEW", '')
    }
    // eslint-disable-next-line
  }, [NameBrandstore]);
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    width <= 767 ? setFiltersideOpen(false) : setFiltersideOpen(true);
    return;
  }, [width]);

  useEffect(() => {
    const searchPrms = {};
    const unique_cats = [
      ...new Set(catWithSubCat.map((item) => item.category)),
    ];
    unique_cats.forEach((cat) => {
      const sub_cats = catWithSubCat.filter(
        (item) => item.category === cat
      );
      const unique_subcats = [
        ...new Set(sub_cats.map((item) => item.subCategory)),
      ].join(",");
      searchPrms[cat] = unique_subcats;
    });
    // setting ends here

    if (FilterFlag) {
      setPage(1);
      setSearchParams({ ...searchPrms, tab_id: urlParams.has("tab_id") ? urlParams.get("tab_id") :''});
    }
    // eslint-disable-next-line
  }, [catWithSubCat]);

  const selectedCssProps = Array.from(document.styleSheets)
    .reduce(
      (acc, sheet) =>
      (acc = [
        ...acc,
        ...Array.from(sheet.cssRules).reduce(
          (def, rule) =>
          (def =
            rule.selectorText === ":root"
              ? [
                ...def,
                ...Array.from(rule.style).filter(name =>
                  name.startsWith("--nv")
                )
              ]
              : def),
          []
        )
      ]),
      []
    );
  useEffect(() => {

    if (activeTab) {
      callEtail("PAGE_CLICK", activeTab?.name);
    }
    if (urlParams.get("tab_id") !== activeTab?.tbId) { setCatWithSubCat([]); }
    const hashUrl = (window.location.hash)
    getData(urlParams.get("tab_id") ? urlParams.get("tab_id") : hashUrl ? hashUrl : null);
    return
    // eslint-disable-next-line
  }, [urlParams.get("tab_id"), urlParams.get("category"), urlParams.get("gpu"), urlParams.get("manufacturer"), priceSort, urlParams.get("screen_size"), urlParams.get("nv_technology"), urlParams.get("ram"), urlParams.get("gpu_memory_size")]);
  useEffect(() => {
    if (ResetFilterState) { getData(urlParams.get("tab_id") ? urlParams.get("tab_id") : ''); setResetFilterState(false) }
    // eslint-disable-next-line
  }, [ResetFilterState]);
  const switchTabs = (tbId) => {
    setIsLoaded(false);
    if (tbId !== urlParams.get("tab_id")) {
      sideBarState.setCatWithSubCat([]);
      setCatWithSubCat([]);
      setFilterFlag(false);
      setSearchParams({ tab_id: tbId });
      // setApplyPriceFilter(false);
      setPage(1);
      // getData(tbId);
      sideBarState.setPriceSort("");
    }
    return
  };
  const siteSideBarStateFn = (cat, values) => {
    let subCategories = values.split(",");
    subCategories?.forEach((val) => {
      list.push({ category: cat, subCategory: val });
      setCatWithSubCat([
        ...catWithSubCat,
        {
          category: cat,
          subCategory: val,
        },
      ]);
    });
  };

  const brandstoreIdMapping = {
    dev: {
      msi: 466,
      asus: 463,
      razer: 473,
      cyberpowerpc:474,
      scan:482,
      zotac:486
    },
    stg: {
      msi: 466,
      asus: 463,
      razer: 473,
      cyberpowerpc:474,
      scan:482,
      zotac:486
    },
    prod: {
      msi: 597,
      asus: 600,
      razer: 617,
      cyberpowerpc:616,
      scan:482,
      zotac:629
    }
  };
//  const [brandstoreIds, setBrandstoreIds] = useState(null);
  const settingStoreId = () =>{
    
    const url = window.location.href.toLowerCase(); // Get current URL
    let environment = 'prod';
    if (url.includes('dev')) {
      environment = 'dev';
    }
    else if (url.includes('stg')) {
      environment = 'stg';
    }
    const brandMatch = url.match(/\/([a-z]{2}-[a-z]{2})\/consumer\/brands\/([a-z]+)/i);
    if (brandMatch && brandMatch.length > 1) {
      const brand = brandMatch[2];
      if (brandstoreIdMapping[environment] && brandstoreIdMapping[environment][brand]) {
        // setBrandstoreIds(brandstoreIdMapping[environment][brand]);
        brandstoreId = brandstoreIdMapping[environment][brand];
        return brandstoreIdMapping[environment][brand];
      }
    }
 
  }
  const getData = (tabId) => {
    const PromoUrl = {
      GameBundle: "GameBundle",
      AppBundle: "AppBundle",
      Promo: "Promo"
    }
    let urlTabParam = PromoUrl[tabId?.replace('#', '')] ? PromoUrl[tabId?.replace('#', '')] : tabId
    const paramType = urlParams.get("tab_id") ? `cid=` + urlTabParam : `&` + urlTabParam ? '' : ''
    const Instock = brandstoreId === "286" ? '&stock=IO&' : '&stock=IS&'
    const sort = priceSort ? '&sort=' + priceSort : ''
    console.log('settingStoreId()',settingStoreId())
    let url =
      `store/products?bhub=`+settingStoreId()+`&store_id=`+settingStoreId()+`&page=${loadMoreProducts ? page : 1}${sort}${Instock}${paramType}`;

    if (applyPriceFilter) {
      url += `&mnp=${Math.round(sideBarState.priceFilter[0])}&mxp=${Math.round(
        sideBarState.priceFilter[1]
      )}
           `;
    }

    let cats = "";
    if (
      (urlParams.get("category") ||
        urlParams.get("gpu") ||
        urlParams.get("manufacturer") ||
        urlParams.get("nv_technology") ||
        urlParams.get("screen_size") ||
        urlParams.get("ram") ||
        urlParams.get("gpu_memory_size")
      )
    ) {

      if (urlParams.get("category")) {
        cats += "&category=" + urlParams.get("category");
        siteSideBarStateFn("category", urlParams.get("category"));
        // list.push({ category: "category", subCategory: urlParams.get("category") });
      }
      if (urlParams.get("gpu")) {
        cats += "&gpu=" + urlParams.get("gpu");
        siteSideBarStateFn("gpu", urlParams.get("gpu"));
        // list.push({ category: "gpu", subCategory: urlParams.get("gpu") });
      }
      if (urlParams.get("manufacturer")) {
        cats += "&manufacturer=" + urlParams.get("manufacturer");
        siteSideBarStateFn("manufacturer", urlParams.get("manufacturer"));
        // list.push({ category: "manufacturer", subCategory: urlParams.get("manufacturer") });
      }
      if (urlParams.get("screen_size")) {
        cats += "&screen_size=" + urlParams.get("screen_size");
        siteSideBarStateFn("screen_size", urlParams.get("screen_size"));
        // list.push({ category: "manufacturer", subCategory: urlParams.get("manufacturer") });
      }

      if (urlParams.get("ram")) {
        cats += "&ram=" + urlParams.get("ram");
        siteSideBarStateFn("ram", urlParams.get("ram"));
        // list.push({ category: "manufacturer", subCategory: urlParams.get("manufacturer") });
      }
      if (urlParams.get("gpu_memory_size")) {
        cats += "&gpu_memory_size=" + urlParams.get("gpu_memory_size");
        siteSideBarStateFn("gpu_memory_size", urlParams.get("gpu_memory_size"));
        // list.push({ category: "manufacturer", subCategory: urlParams.get("manufacturer") });
      }
      if (urlParams.get("nv_technology")) {
        cats += "&nv_technology=" + urlParams.get("nv_technology");
        siteSideBarStateFn("nv_technology", urlParams.get("nv_technology"));
        // list.push({ category: "manufacturer", subCategory: urlParams.get("manufacturer") });
      }

      sideBarState.setCatWithSubCat(list);

    }
    else {
      const unique_cats = [
        ...new Set(catWithSubCat.map((item) => item.category)),
      ];
      unique_cats?.forEach((cat) => {
        const sub_cats = catWithSubCat.filter((item) => item.category === cat);
        const unique_subcats = [
          ...new Set(sub_cats.map((item) => item.subCategory)),
        ].join(",");
        cats += "&" + cat + "=" + unique_subcats;
      });
    }
    // Set the headers in the instance
    const token_id = urlParams.get("t");
    axiosInstance.defaults.headers.common['Authorization'] = token_id ? "Bearer " + token_id : '';
    axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

    axiosInstance
      .get(url?.trim() + cats?.trim())
      .then((res) => {
        const data = JSON.parse(res.data);
        setLocale(data?.locale)
        setTabList(data?.tabs);

        !loadMoreProducts
          ? setProductsList(data?.searchedProducts?.productDetails)
          : setProductsList([
            ...productsList,
            ...data?.searchedProducts?.productDetails,
          ]);
        setPagination(data?.pagination);
        let activeTabs = data?.tabs?.filter((x, index) =>
          urlTabParam ? x.tbId === urlTabParam : index === 0
        );
        // eslint-disable-next-line
        activeTabs = activeTabs.length == 0 ? data?.tabs?.filter((x, index) =>
          // urlTabParam ? x.name.replace(/\s/g, '') === urlTabParam.replace(/#|%20/g, '') : index === 0
          urlTabParam ? x.promoType === tabId.replace('#', '') : index === 0
        ) : activeTabs
        const activeTabId = activeTabs[0]?.tbId;
        setdefaultSortValue(activeTabs[0]?.defaultSort);
        setActiveTab(activeTabs[0]);
        const banners = data?.heroBanners[activeTabId];
        setHomeBanners(data?.homeBanners[activeTabs[0]?.tbcId]);
        const redirectUrlBanner = data?.heroBanners["tb_id" + activeTabs[0]?.id]?.imgRedirectUrl;
        redirectUrlBanner ? setRedirectUrl(redirectUrlBanner) : setRedirectUrl('');
        setHeroBanner(banners);
        //set categories in url


        const component = activeTabs[0]?.components;
        const filterbanner = component?.filterBanner || "";
        const heroBannr = component?.heroBanner || "";
        const promoBannr = component?.promotionalBanner || "";
        //TO DO: check logic to prevent components API call
        if (1) {
          let componentsUrl =
            "json=[]&filterBanner=[" +
            filterbanner +
            "]&heroBanner=[" +
            heroBannr +
            "]&promotionalBanner=[" +
            promoBannr +
            "]";
          axiosComponentsAPIInstance.get(componentsUrl).then((res) => {
            // console.log(
            //   "getPromoBanners=>",
            //   getPromoBanners(res?.data?.promotionalBanner)
            // );
            // console.log(
            //   "getFilterBanners=>",
            //   getPromoBanners(res?.data?.filterBanner.properties)
            // );
            // console.log("promoBanner data",res?.data?.promotionalBanner);
            setPromoBanners(getPromoBanners(res?.data?.promotionalBanner));
            const filterbanner = res?.data?.filterBanner;
            if (filterbanner) {
              setnew_arr1(filterbanner?.map((f) => f?.properties))
            }



          });
          //call components API if required



        }

        //set Sidebar details
        const new_arr = data.filters.filter((f) => f.displayName !== "Stock");
        sideBarState.setCategories(new_arr);
        setNoProductFlag(new_arr.length > 0 ? true : false)
        const defaultPriceRange = data.filters.filter((f) => f.displayName === "price");
        const minValue = defaultPriceRange[0]?.selectedMinRangeVal;
        const maxValue = defaultPriceRange[0]?.selectedMaxRangeVal;
        if (minValue !== undefined) {
          setPriceFilter([
            (minValue === 0 || isNaN(minValue) || minValue === maxValue) ? 10 : defaultPriceRange[0]?.selectedMinRangeVal,
            defaultPriceRange[0]?.selectedMaxRangeVal || 10000,
          ]);
          setSliderMinMax([
            (minValue === 0 || isNaN(minValue) || minValue === maxValue) ? 10 : defaultPriceRange[0]?.defaultMinRangeVal,
            defaultPriceRange[0]?.defaultMaxRangeVal || 10000,
          ]);
        }

        // console.log("defaultPriceRange[0]", defaultPriceRange[0]);
        setIsLoaded(true);
        // console.log("productState", productState);
        // console.log("sideBarStates", sideBarState);
        setNameBrandstore(data?.displayName);
      })
      .catch((error) => {
        console.error(error);
      });

    selectedCssProps.forEach(prop => {
      try {
        // set each selected variable with its analogous variable from the new theme
        document.documentElement.style.setProperty(prop, `var(--${themename}${prop.substring(4)})`);
      } catch (error) {
        console.log(error);
      }

    });
  };
  const getCookie = (name) => {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
  }
  const callEtail = (type, url) => {
    let device_info = deviceInfo();
    var _vid = getCookie('edge');
    let event_Name = ''
    brandstoreName === "NewEggUS" ? event_Name = "" : event_Name = brandstoreName + '_';
    let all_info = {
      agent: device_info.agent,
      browser: device_info.browser,
      device: device_info.device,
      id: null,
      isMobile: device_info.isMobile,
      language: device_info.language,
      latitude: null,
      longitude: null,
      os: device_info.os,
      refererUrl: document.referrer,
      remoteAddress: null,
      section: url || sideBarState.currentFilter.section,
      type: event_Name + type || event_Name + sideBarState.currentFilter.type,
      url: sideBarState.currentFilter.url,
      visitorId: _vid == null ? "" : _vid,
    };
    const urlParams = new URLSearchParams(location.search);
    var superType = "others";

    if (type === 'PAGE_VIEW' || type === 'PAGE_CLICK') {
      superType = "Traffic"
    }
    if (type === 'PDP_CLICK') {
      superType = "Leads"
      urlParams.get('category') ? type = 'PG_FILTER_PRODUCT_CLK' : type = 'PG_PRODUCT_CLK'
    }
    if (type === 'BUY_NOW') {
      superType = "Leads"
      urlParams.get('category') ? type = 'PG_FILTER_BUY_NOW_CLK' : type = 'BUY_NOW'
    }
    let all_info_v3 = {
      // eslint-disable-next-line
      banner: type == 'PG_BANNER_CLK' ? url || sideBarState.currentFilter.section : '',
      // eslint-disable-next-line
      productTitle: type == 'PG_FILTER_PRODUCT_CLK' || type == 'PG_PRODUCT_CLK' ? url || sideBarState.currentFilter.section : '',
      category: sideBarState.currentFilter.catWithSubCat,
      group: "BrandStore",
      locale: locale,
      refererUrl: document.referrer,
      subGroup: NameBrandstore,
      superType: superType,
      type: type || sideBarState.currentFilter.type,
      url: sideBarState.currentFilter.url,
      tabName: activeTab?.name,
      section: url || sideBarState.currentFilter.section,
      userAgent: device_info.agent,
      version: "v3",
      visitorId: "",
      os: device_info.os,
      device: device_info.device,
      browser: device_info.browser,
      language: device_info.language,
      agent: device_info.agent
    }
    try {
      const headers = {
        'Content-Type': 'application/json'
      }
      axiosInstance.post(`/telemetry/v1/activity/etail`, all_info_v3, {
        headers: headers,
        withCredentials: true,
        crossDomain: true
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        })

      axiosInstance.post(`/telemetry/v1/activity/etail`, all_info, {
        headers: headers,
        withCredentials: true,
        crossDomain: true
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        })
    } catch (error) {
      console.log(error)
    }
  };

  const deviceInfo = () => {
    let device = navigator.userAgent
      .toLowerCase()
      .match(/iPhone|iPad|iPod|Tablet|Mobile|Android|BlackBerry|Opera Mini/i);
    let os = navigator.userAgent
      .toLowerCase()
      .match(/Window|macintosh|Ubuntu|Linux; Android|Android|Linux/i);
    let browser = null;
    if (navigator.userAgent.toLowerCase().match(/MSIE/i)) {
      browser = "EDGE";
    } else if (navigator.userAgent.toLowerCase().match(/EDG/i)) {
      browser = "EDGE";
    } else if (navigator.userAgent.toLowerCase().match(/Firefox/i)) {
      browser = "Firefox";
    } else if (navigator.userAgent.toLowerCase().match(/Chrome/i)) {
      browser = "Chrome";
    } else if (navigator.userAgent.toLowerCase().match(/Opera/i)) {
      browser = "Opera";
    } else if (navigator.userAgent.toLowerCase().match(/Safari/i)) {
      browser = "Safari";
    }
    // let deviceTypes = ['mobile', 'ipad', 'tablet', 'desktop', 'laptop'];
    let info = {
      os: os ? os[0] : null,
      device: device ? device[0] : "Desktop/Laptop",
      isMobile: device ? true : false,
      browser: browser,
      language: navigator.language,
      agent: navigator.userAgent,
    };
    return info;
  };

  const loadMore = (pg) => {
    setLoadMoreProducts(true);
    setPage(pg + 1);
  };

  useEffect(() => {
    if (loadMoreProducts) {
      getData(urlParams.get("tab_id") ? urlParams.get("tab_id") : null);
      setLoadMoreProducts(false);
    }
    // eslint-disable-next-line
  }, [page]);



  useEffect(() => {
    if (applyPriceFilter) {
      APIcalling();
    }
    setApplyPriceFilter(false);
    // eslint-disable-next-line
  }, [applyPriceFilter]);
  //API call on price filter change
  const APIcalling = useDebounce(() => {
    // if(isLoaded){
    // callEtail("FILTER_CLICK");
    getData(urlParams.get("tab_id") ? urlParams.get("tab_id") : null);
    // }
  }, 300);
  function useDebounce(func, delay) {
    const [timer, setTimer] = useState(null);
    return (...args) => {
      clearTimeout(timer);
      let _temp = setTimeout(() => {
        func(...args);
      }, delay);
      setTimer(_temp);
    };
  }
  const dynamicElementRefs = useRef([]);
  function handleTabClick(index) {
    if (dynamicElementRefs?.current) {
      dynamicElementRefs?.current[index].click()
    }
  }

  // const sortedProducts = [...retailProductObject].sort((a, b) => {
  //   debugger
  //   // If a's productUrl is 'nvidia', it should come before b
  //   if (a.purchaseLink.includes('store.nvidia.com')) return -1;
  //   // If b's productUrl is 'nvidia', it should come after a
  //   if (b.purchaseLink.includes('store.nvidia.com')) return 1;
  //   // For other cases, maintain the current order
  //   return 0;
  // });

  useEffect(() => {
    const url = window.location.href.toLowerCase(); // Get current URL
    const brandMatch = url.match(/\/([a-z]{2}-[a-z]{2})\/consumer\/brands\/([a-z]+)/i);
    const metaValue = {
      asus: {
        title: 'ASUS Partner-shipped Products - NVIDIA Brand Hub',
        description: 'Buy ASUS NVIDIA GeForce Products from the official NVIDIA Consumer Marketplace. Explore the list of ASUS Partner-shipped Products.'
      },
      msi: {
        title: 'MSI Partner-shipped Products - NVIDIA Brand Hub',
        description: 'Buy MSI NVIDIA GeForce Products from the official NVIDIA Consumer Marketplace. Explore the list of MSI Partner-shipped Products.'
      },
      cyberpowerpc: {
        title: 'CyberPowerPC Partner-shipped Products - NVIDIA Brand Hub',
        description: 'Buy CyberPowerPC NVIDIA GeForce Products from the official NVIDIA Consumer Marketplace. Explore the list of CyberPowerPC Partner-shipped Products.'
      },
      razer: {
        title: 'Razer Partner-shipped Products - NVIDIA Brand Hub',
        description: 'Buy Razer NVIDIA GeForce Products from the official NVIDIA Consumer Marketplace. Explore the list of Razer Partner-shipped Products.'
      },
      scan: {
        title: 'Scan Partner-shipped Products - NVIDIA Brand Hub',
        description: 'Buy Scan NVIDIA GeForce Products from the official NVIDIA Consumer Marketplace. Explore the list of Scan Partner-shipped Products.'
      },
      zotac: {
        title: 'Zotac Partner-shipped Products - NVIDIA Brand Hub',
        description: 'Buy Zotac NVIDIA GeForce Products from the official NVIDIA Consumer Marketplace. Explore the list of Zotac Partner-shipped Products.'
      }
    };
    const canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    canonicalLink.href = window.location.href;
    document.head.appendChild(canonicalLink);
    



    const brand = brandMatch[2];
    const getMetaData = metaValue[brand];
    console.log("getMetaData",getMetaData.title)

    const meta = document.createElement('meta');
    meta.name = "title";
    meta.content = getMetaData.title;
    document.head.appendChild(meta);

    document.title = getMetaData.title;

    const metaDesc = document.createElement('meta');
    metaDesc.name = "description";
    metaDesc.content = getMetaData.description;
    document.head.appendChild(metaDesc);

    // Open Graph tags
    const ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.content = getMetaData.title;
    document.head.appendChild(ogTitle);

    const ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    ogDescription.content = getMetaData.description;
    document.head.appendChild(ogDescription);
    
    const ogUrlMeta = document.createElement('meta');
    ogUrlMeta.setAttribute('property', 'og:url');
    ogUrlMeta.content = window.location.href;
    document.head.appendChild(ogUrlMeta);

    // Twitter tags
    const twitterTitle = document.createElement('meta');
    twitterTitle.setAttribute('name', 'twitter:title');
    twitterTitle.content = getMetaData.title;
    document.head.appendChild(twitterTitle);

    const twitterDescription = document.createElement('meta');
    twitterDescription.setAttribute('name', 'twitter:description');
    twitterDescription.content = getMetaData.description;
    document.head.appendChild(twitterDescription);

    const twitterMeta = document.createElement('meta');
    twitterMeta.name = 'twitter:url';
    twitterMeta.content = window.location.href; // Use dynamic URL from props
    document.head.appendChild(twitterMeta);


    // Cleanup function to remove the meta tags if needed


    return () => {
        document.head.removeChild(meta);
        document.head.removeChild(metaDesc);
        document.head.removeChild(ogTitle);
        document.head.removeChild(ogDescription);
        document.head.removeChild(ogUrlMeta);
        document.head.removeChild(twitterTitle);
        document.head.removeChild(twitterDescription);
        document.head.removeChild(canonicalLink);
        document.head.removeChild(twitterMeta);
        
    };
}, []);
  return  <>
     {headerData&&<GlobalHeader
                apiData={headerData || []}
                isStoreHeaderAvailable={true}
                userIcon={true}
                cartIcon={false}
            />}
      {!isLoaded ? (
        <div
          className={
            "spinner-border text-dark spinnerLocation " +
            (theme_clr === "dark" ? "bgDark" : "bgLight")
          }
          role="status"
        >
          <img src={loaderIcon} width={50} alt="loaderIcon" />
        </div>
      ) : (locale && (

        <div className={theme_clr === "dark" ? "bgDark" : "bgLight"}>
          <div className="nv-store-body">
            <div
              className={
                "Breadcrumb" +
                (theme_clr === "dark" ? " text-color-dark " : " text-color-light")
              }
            >
              <span className="breadcrumb-text"><a href="/en-us/">Marketplace</a></span><span className="breadcrumb-slash">/</span>
              <span className="breadcrumb-text"><a href="/en-us/consumer/">Consumer</a></span><span className="breadcrumb-slash">/</span>
              <span className="breadcrumb-text">Brands</span><span className="breadcrumb-slash">/</span>
              
              {/* <span className="breadcrumb-arrow">
                      <svg viewBox="0 0 30 30" data-testid="kui-icon" fill="#8bc34a" height="12" width="12">
                        <defs>
                          <path d="M7.25 30a1.05 1.05 0 01-.896-.468c-.523-.584-.467-1.168.168-1.753l14.453-12.74L6.522 2.299c-.635-.585-.69-1.17-.168-1.754.56-.663 1.12-.721 1.68-.175l15.518 13.734c.299.233.448.545.448.935s-.15.701-.448.935L8.035 29.708c-.262.195-.523.292-.785.292z" id="arrow-caret-right-solid_svg__a"></path>
                        </defs>
                        <use xlinkHref="#arrow-caret-right-solid_svg__a" fillRule="evenodd"></use>
                      </svg>
                    </span> */}
              <h1>{activeTab?.name?.split(' ')[0]}</h1>
            </div>
              <HomeBanner
                heroBanner={heroBanner}
                redirectURL={redirectURL}
                etailCall={callEtail}
              />
            <div className="header-wrapper nv-col-12">
              {/* <HomeBanner
                heroBanner={heroBanner}
                redirectURL={redirectURL}
                etailCall={callEtail}
              /> */}
              <div className="nv-row">

                <div span={11} gutter={2} className="nv-navigation nv-col-11">

                  <div>
                    <div
                      className={
                        "nv-tab" +
                        (theme_clr === "dark" ? " text-color-dark " : " text-color-light")
                      }
                    >
                      <ul>
                        {tabList && tabList.length > 0 && activeTab ? (
                          tabList.map((tab, index) => {
                            return (
                              index <= 6 &&
                              tab?.active &&
                              tab?.parentId === 0 && (
                                <div className="nv-tabWrapper" key={tab.name + "_" + index}>
                                  <li
                                    className={
                                      "nv-tablinks" +
                                      (tab?.tbId === activeTab?.tbId ? " active " : "")
                                    }
                                  >
                                    <span
                                      onClick={() => {
                                        let tabvalidname = '';
                                        tabList.filter((subtab) => {
                                          if (subtab.parentId !== 0 && subtab.parentId === tab?.id) {
                                            tabvalidname = tab.tbId;
                                            return true; // Include this subtab in the filtered array
                                          }
                                          return false; // Exclude this subtab from the filtered array
                                        });
                                        if (tab?.tbId === tabvalidname) {
                                          if (dynamicElementRefs.current) {
                                            handleTabClick(index);
                                          }
                                          return;
                                        } else if (tab?.tbId !== activeTab?.tbId) {
                                          setIsLoaded(false);
                                          setActiveTab(tab);
                                          switchTabs(tab.tbId);
                                        }
                                      }}
                                    >
                                   {index===0?<h1 className="Brand-Title">{tab.name}</h1>:tab.name}   
                                    </span>
                                  </li>
                                </div>
                              )
                            );
                          })
                        ) : null}
                        {tabList.filter((tabList) => tabList?.parentId === 0).length >
                          7 && tabList ? (
                          <li
                            className="nv-tablinks"
                            onClick={() => setIsOpen((x) => !x)}
                          >
                            {localeStrings?.more}{" "}
                          </li>
                        ) : null}
                      </ul>
                    </div>
                  </div>
                  {width <= 767 ? (
                    <div className="nv-row">
                      <div span={12} className="nv-menuButtonDIv">
                        <Button
                          shape="rectangle"
                          size="regular"
                          tag="button"
                          variant="solid"
                          className="menuIcon"
                          onClick={() => setIsOpen((x) => !x)}
                        >
                          Menu
                        </Button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="nv-row nv-product-tile">
              {productsList
                .filter(item => item.isFeaturedProduct === true)
                .slice(0, 4)
                .map((item, i) => (
                  activeTab?.name.toLowerCase() !== localeStrings?.homeTab && <ItemProductPanel
                    item={item}
                    key={`itemGrid-${i}`}
                    theme={theme_clr}
                    currency={localeStrings?.currency}
                    etailCall={callEtail}
                    productInfo={localeStrings?.productInfo}
                    buttonText={localeStrings?.ButtonText}
                    ViewDetails={localeStrings?.viewDetails}
                    CategoryValue={urlParams.get("category") ? urlParams.get("category") : 'GPU'}
                    categoryArr={spec}
                    locale={locale}
                    setOpenRetailDetail={setOpenRetailDetail}
                    setRetailProductObject={setRetailProductObject}
                    setRetailProductTitle={setRetailProductTitle}
                  />
                ))
              }
            </div>
            <div className="nv-col-12">
              <div className="nv-row">
                {activeTab?.name.toLowerCase() !== localeStrings?.homeTab &&
                  activeTab?.name !== "SHIELD" &&
                  NoProductFlag &&
                  (isFiltersideOpen ? (
                    <div span={2} className="sidebarFilter nv-col-2">
                      <SideBar
                        theme={theme_clr}
                        tabActive={activeTab}
                        etailCall={callEtail}
                        loader={setIsLoaded}
                        FilterFlag={FilterFlag}
                        setFilterFlag={setFilterFlag}
                        locale={locale}
                        setResetFilterState={setResetFilterState}
                      />
                    </div>
                  ) : null)}
                <div
                  className={`${activeTab?.name.toLowerCase() !== localeStrings?.homeTab &&
                    activeTab?.name !== "SHIELD" &&
                    NoProductFlag
                    ? "nv-col-10"
                    : "nv-col-12"} nv-border-left`
                  }
                >
                  <Tag 
                  setCatWithSubCat={setCatWithSubCat} 
                  setResetFilterState={setResetFilterState} 
                  catWithSubCat={ Array.from(new Set(catWithSubCat))}
                  theme={theme_clr}
                  tabActive={activeTab}
                  etailCall={callEtail}
                  loader={setIsLoaded}
                  FilterFlag={FilterFlag}
                  setFilterFlag={setFilterFlag}
                  locale={locale}                  
                  ></Tag>
                  {/* Products Listing */}
                  <div className="productList nv-col-12">
                    {activeTab?.name.toLowerCase() !== localeStrings?.homeTab &&
                      activeTab?.name !== "SHIELD" &&
                      NoProductFlag &&
                      isLoaded && (
                        <>
                          {width <= 767 ? (
                            <div className="nv-row">
                              {activeTab?.name.toLowerCase() !==
                                localeStrings?.homeTab ? (
                                <div className="border-bottom nv-col-12">
                                {!isFiltersideOpen&&<Button
                                    shape="rectangle"
                                    size="regular"
                                    tag="button"
                                    variant="solid"
                                    className="filterIcon"
                                    onClick={() => setFiltersideOpen((x) => !x)}
                                  >
                                    Filter
                                  </Button>}
                                  {isFiltersideOpen&&<Button
                                    shape="rectangle"
                                    size="regular"
                                    tag="button"
                                    variant="solid"
                                    className="closeIcon"
                                    onClick={() => setFiltersideOpen((x) => !x)}
                                  > 
                                  </Button>}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            ""
                          )}

                          <Flex>

                            {/* <div className="flex-start"> */}
                            <div className="nv-count-wrap">
                              <h4 className="float-right">
                                {pagination?.totalRecords}{" "}
                                {localeStrings?.ResultFound}
                              </h4>
                            </div>

                            {/* </div> */}
                            <div >
                           {/* <span><h4 className="gridView">
                              {localeStrings?.sortLabel}{" "}
                            </h4></span>  */}
                            
                            <Select
                              className="nv-sortby-menu"
                              // css={{ "margin-top": "10px", "width": "10em"}}
                              size={"medium"}
                              /* eslint-disable no-useless-concat */
                              placeholder={localeStrings?.[sortingValue[0][defaultSortValue]] ? "Sort By: " +  localeStrings?.[sortingValue[0][defaultSortValue]] :"Sort By: " +'Lowest Price'}
                              /* eslint-enable no-useless-concat */
                              options={[
                                {
                                  label: localeStrings?.LowestPrice,
                                  value: "lp",
                                },
                                {
                                  label: localeStrings?.HighestPrice,
                                  value: "hp",
                                },
                                {
                                  label: localeStrings?.FeaturedProducts,
                                  value: "fp",
                                },
                                // {
                                //   label: localeStrings?.Rating,
                                //   value: "rt",
                                // },
                                // {
                                //   label: localeStrings?.DiscountedPrice,
                                //   value: "dp",
                                // },
                              ]}
                              onChange={(e) => {
                                setPriceSort(e);
                              }}

                              renderItem={(item, index) => (
                                <SelectItem
                                  className="nv-sortby-menu-select"
                                  css={{ "padding": "10px", "fontSize": "11px" }}
                                  key={index}
                                  size={"medium"}
                                  value={item.value}
                                  disabled={item.value === 'Pears'}
                                >
                                  {item.label}
                                </SelectItem>
                              )}
                            />
                            </div>
                            {/* <div className="flex-end">
                              <h4 className="gridView">
                                {localeStrings?.ViewButton}:{" "}
                              </h4>
                              <div
                                className={
                                  view === "GridView"
                                    ? "list-view-default"
                                    : "list-view-active"
                                }
                                onClick={(e) => setView("ListView")}
                              ></div>
                              <div
                                className={
                                  view === "GridView"
                                    ? "grid-view-active"
                                    : "grid-view-default"
                                }
                                onClick={(e) => setView("GridView")}
                              ></div>
                            </div> */}
                          </Flex>
                        </>
                      )}

                    <div className="nv-col-6">
                      <div>
                        {/* code for Carousel  */}
                      </div>
                    </div>
                    <div className="homeBannersGrid nv-row">
                      {homeBanner?.length > 0 &&
                        homeBanner.map((banner, index) => {
                          return (
                            // eslint-disable-next-line
                            banner.contentSize == 25 && (
                              <div
                                className={
                                  banner.contentSize === "25"
                                    ? "columns-3 nv-col-3"
                                    : banner.contentSize === "50L"
                                      ? "columns-6 grid-row nv-col-6"
                                      : banner.contentSize === "50"
                                        ? "columns-6 horizontalAlign nv-col-6"
                                        : "columns-12 nv-col-12"
                                }
                                span={
                                  banner.contentSize === "25"
                                    ? 3
                                    : banner.contentSize === "50L" ||
                                      banner.contentSize === "50"
                                      ? 6
                                      : 12
                                }
                                key={activeTab?.tbId + banner?.title + index}
                              >
                                {banner.type === "image" && (
                                  <ImageBanner banner={banner} etailCall={callEtail} />
                                )}
                              </div>
                            )
                          );
                        })}
                    </div>
                    <div className="nv-row">
                      {productsList.map((item, i) => (
                        // item.isFeaturedProduct&&
                        activeTab?.name.toLowerCase() === localeStrings?.homeTab && (
                          <ItemGridView
                            item={item}
                            key={`itemGrid-${i}`}
                            theme={theme_clr}
                            currency={localeStrings?.currency}
                            etailCall={callEtail}
                            productInfo={localeStrings?.productInfo}
                            buttonText={localeStrings?.ButtonText}
                            ViewDetails={localeStrings?.viewDetails}
                            CategoryValue={
                              urlParams.get("category")
                                ? urlParams.get("category")
                                : "GPU"
                            }
                            categoryArr={spec}
                            locale={locale}
                            hometab={localeStrings?.homeTab}
                            setOpenRetailDetail={setOpenRetailDetail}
                            setRetailProductObject={setRetailProductObject}
                            setRetailProductTitle={setRetailProductTitle}
                          />
                        )
                      ))}
                      {view === "GridView"
                        ? productsList?.map((item, i) => (
                          //  !item.isFeaturedProduct&&
                          activeTab?.name.toLowerCase() !==
                          localeStrings?.homeTab && (
                            <ItemGridView
                              item={item}
                              key={`itemGrid-${i}`}
                              theme={theme_clr}
                              currency={localeStrings?.currency}
                              etailCall={callEtail}
                              productInfo={localeStrings?.productInfo}
                              buttonText={localeStrings?.ButtonText}
                              ViewDetails={localeStrings?.viewDetails}
                              CategoryValue={
                                urlParams.get("category")
                                  ? urlParams.get("category")
                                  : "GPU"
                              }
                              categoryArr={spec}
                              locale={locale}
                              count={i}
                              setOpenRetailDetail={setOpenRetailDetail}
                              setRetailProductObject={setRetailProductObject}
                              setRetailProductTitle={setRetailProductTitle}
                            />
                          )
                        ))
                        : null
                      }
                      {productsList.length !== 0 &&
                        productsList.length < pagination?.totalRecords &&
                        activeTab?.name.toLowerCase() !== localeStrings?.homeTab && (
                          <div className="nv-col-12">
                            <Button
                              shape="rectangle"
                              size="regular"
                              tag="button"
                              variant="solid"
                              className="loadmore-btn"
                              onClick={() => loadMore(page)}
                            >
                              {localeStrings?.loadMore
                                ? localeStrings?.loadMore
                                : "Load More"}
                            </Button>
                          </div>
                        )}
                    </div>
                  </div>
                  {/* Products Listing */}
                  <div className="ZeroPadding nv-col-12">
                    <div className="homeBannersGrid nv-row">
                      {homeBanner?.length > 0 &&
                        homeBanner.map((banner, index) => {
                          return (
                            // eslint-disable-next-line
                            banner.contentSize != 25 && (
                              <div
                                className={
                                  banner.contentSize === "25"
                                    ? "columns-3 nv-col-3 "
                                    : banner.contentSize === "50L"
                                      ? "columns-6 grid-row nv-col-6"
                                      : banner.contentSize === "50"
                                        ? "columns-6 horizontalAlign nv-col-6"
                                        : "columns-12 nv-col-12"
                                }
                                span={
                                  banner.contentSize === "25"
                                    ? 3
                                    : banner.contentSize === "50L" ||
                                      banner.contentSize === "50"
                                      ? 6
                                      : 12
                                }
                                key={activeTab?.tbId + banner?.title + index}
                              >
                                {banner.type === "image" && (
                                  <ImageBanner banner={banner} />
                                )}
                              </div>
                            )
                          );
                        })}
                    </div>

                    <div className="promoBannerGrid nv-row">
                      {promoBanners?.length > 0 &&
                        promoBanners.map((banner, index) => {
                          return (
                            <div
                              className={
                                (banner.contentSize === "100"
                                  ? "columns-12 nv-col-12"
                                  : "columns-6 nv-col-6") +
                                (banner.type === "video" &&
                                  activeTab?.name.toLowerCase() !==
                                  localeStrings?.homeTab
                                  ? " mb4"
                                  : "")
                              }
                              // eslint-disable-next-line
                              span={banner.contentSize == "100" ? 12 : 6}
                              key={activeTab?.tbId + banner?.title + index}
                            >
                              {/* {banner.contentSize} */}
                              {banner.type === "image" && (
                                <ImageBanner banner={banner} />
                              )}
                              {banner.type === "video" && (
                                <VideoBanner
                                  banner={banner}
                                  setOpenPreviewModal={setOpenPreviewModal}
                                  setCurrentVideoUrl={setCurrentVideoUrl}
                                  etailCall={callEtail}
                                />
                              )}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nv-col-6">
              <div className="nv-row">
                <div span={6} className="sidebar nv-col-6">
                  <SideMenu
                    tabData={tabList}
                    switchtabs={switchTabs}
                    onClickOutside={() => {
                      setIsOpen(false);
                    }}
                    etailCall={callEtail}
                    ButtonText={localeStrings?.backToStore}
                  ></SideMenu>
                </div>
              </div>
            </div>
          </div>
          <Modal
            className="nv-video-previewModal"
            open={openPreviewModal}
            backdrop
            closeButton
            closeEcapeKey
            closeOnBackdropClick
            onClose={() => {
              setOpenPreviewModal(false);
              setCurrentVideoUrl("");
            }}
            size="large"
          >
            <iframe
              id="VidModal"
              width="100%"
              height="0"
              src={currentVideoUrl}
              frameBorder="0"
              allowFullScreen
              title="Promo video"
            ></iframe>
          </Modal>

          {/* for product popup modal */}
          {/* <Modal style={{ "backgorund": "rgba(0, 0, 0, 0.6)" }}
            onOpenChange={() => { setOpenRetailDetail(false) }}
            open={openRetailDetail}
            displayName="BuynNowModal"
          >
            <ModalContainer size="large"
              css={{ "background": "#1a1a1a", "color": "#ccc", "width": "900px" }}
            >
              <ModalTitle css={{ "color": "#ccc", "font-size": "24px" }}>
                {retailProductTitle}
              </ModalTitle>
              <ModalContent>
                {

                  sortedProducts.length && sortedProducts?.map((retail, index) => {
                    return (
                      <>

                        <div className="nv-row nv-retailer-wrapper">
                          <div className="popCell">
                            <img src={retail?.logoUrl} alt="product-img" /></div>
                          <div className="popCell"> <span className="nv-retail-price">${retail?.salePrice}</span></div>
                          <div className="popCell"> <Button className="nv-retail-button"                         >
                            <a href={retail.productUrl ? retail.productUrl : retail.purchaseLink} target="_blank" rel="noreferrer"> Buy Now</a>
                          </Button>
                          </div></div>


                      </>
                    )
                  })
                }
              </ModalContent>
            </ModalContainer>
          </Modal> */}
        </div>
      ))}
{isLoaded&&<Footer
                footerTableItems={headerData?.NVIDIAglobalFooter[0]?.footerTableItems || headerData?.NVIDIAsubBrandFooter[0]?.footerTableItems}
                globalFooterLegalLinks={
                  headerData?.NVIDIAglobalFooter[0]?.globalFooterLegalLinks
                }
                // showCountrySelector={showCountrySelector}
                // countries={countries}
                // countrySelectorRedirectUrl={countrySelectorRedirectUrl}
                countryTitle={headerData?.NVIDIAglobalFooter[0]?.country}
                socialItems={headerData?.NVIDIAglobalFooter[0]?.socialItems?.[0]}
                socialLabel={headerData?.NVIDIAglobalFooter[0]?.socialLabel}
                // subscribeLabel={subscribeLabel}
                // subscribeURL={subscribeURL}
                // subscribetext={subscribetext}
            />}
    </>
};
export default Index;
